import { API_BASE } from './apiBase';

const headers = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`
});

const request = async (path: string, options: RequestInit = {}) => {
  const response = await fetch(`${API_BASE}/entreprises${path}`, { ...options, headers: { ...headers(), ...(options.headers || {}) } });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Erreur lors de la gestion des entreprises');
  return body;
};

export const getEntreprises = () => request('/');
export const createEntreprise = (data: Record<string, unknown>) => request('/', { method: 'POST', body: JSON.stringify(data) });
export const updateEntreprise = (id: number, data: Record<string, unknown>) => request(`/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const getEntrepriseCourante = () => request('/current');
